import { useContext, useState } from 'react';
import { eqProps, pick } from 'ramda';
import { useMountEffect } from 'js/hooks/useMountEffect';
import { ListContext } from '../context';
import { fetchDetails, updateListAction } from '../actions';
import { isLeaderBoardEligible } from '../helpers';
import { usePushSubscription } from 'server';

export default (props) => {
    const { state: { leaderboards = [] }, dispatch } = useContext(ListContext);
    const [summary, setSummary] = useState(null);
    const updateState = update => dispatch(updateListAction(update));
    const findAmongExistingLB = lb => leaderboards.find(item => eqProps('leaderboardId', item, lb));
    const { type } = props;

    usePushSubscription(71032, () => details => updateState(details.data));
    usePushSubscription(71031, () => setSummary);

    useMountEffect((isMounted) => {
        if (!summary) {
            return;
        }

        const { data: update } = summary;

        if (!findAmongExistingLB(update) && isLeaderBoardEligible(type)(update)) {
            fetchDetails(pick(['leaderboardId'], update))
                .then(({ data }) => isMounted() && updateState(data.leaderboardDetails))
                .catch(() => isMounted() && updateState(update));
        } else {
            updateState(update);
        }

        setSummary(null);
    }, [summary]);
};
